const isRelatedMetricDocumentsSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.RelatedMetricDocumentsSection => {
  return s.sectionType === 'Related Metric Documents';
};

export default isRelatedMetricDocumentsSection;
